export const wiki = {
  wiki: 'Wiki',
  homeH1: 'CS2-Skin-Wiki',
  homeSubtitle: 'Alle CS2-Skins: Abnutzung, Seltenheit, Cases und Kollektionen',
  categoriesTitle: 'Kategorien',
  featuredTitle: 'Skins im Detail',
  allWeaponsTitle: 'Alle Waffen',
  aboutWiki: 'Über das Wiki',
  readMore: 'Weiterlesen',
  showAll: 'Alle {{count}} anzeigen',
  floatScaleLabel: 'Float-Skala von 0 bis 1 und der Zustand für jeden Bereich',
  searchPlaceholder: 'Suche einen Skin, eine Waffe oder ein Case',
  searchPlaceholderShort: 'Skin, Waffe oder Case',
  searchSubmit: 'Suchen',
  searchClear: 'Suche löschen',
  searchH1: 'Im Wiki suchen',
  searchResultsFor: 'Ergebnisse für „{{q}}“',
  searchEmptyTitle: 'Nichts gefunden',
  searchEmptyText: 'Prüf die Schreibweise oder probier den englischen Namen.',
  searchEmptyTextLatin: 'Prüf die Schreibweise oder kürze die Suche.',
  searchOpenCatalog: 'Katalog öffnen',
  searchErrorTitle: 'Suche wurde nicht geladen',
  searchErrorText: 'Prüf deine Verbindung und such noch einmal.',
  searchShortQuery: 'Gib mindestens zwei Zeichen ein.',
  retry: 'Nochmal versuchen',
  suggestEmpty: 'Keine Treffer',
  suggestAll: 'Alle Ergebnisse anzeigen',
  typeSkin: 'Skin',
  typeWeapon: 'Waffe',
  typeContainer: 'Case',
  typeCollection: 'Kollektion',
  catPistols: 'Pistolen',
  catRifles: 'Gewehre',
  catSmgs: 'MPs',
  catHeavy: 'Schwer',
  catKnives: 'Messer',
  catGloves: 'Handschuhe',
  catEquipment: 'Ausrüstung',
  weaponsTitle: 'Waffen',
  modelsTitle: 'Modelle',
  selectionsTitle: 'Zusammenstellungen',
  guidesTitle: 'Ratgeber',
  containersTitle: 'Neueste Cases',
  allSkins: 'Alle Skins',
  allGuides: 'Alle Ratgeber',
  allSelections: 'Alle Zusammenstellungen',
  allCases: 'Alle Cases',
  allCollections: 'Alle Kollektionen',
  skinsOne: '{{count}} Skin',
  skinsFew: '{{count}} Skins',
  skinsMany: '{{count}} Skins',
  knivesOne: '{{count}} Messer',
  knivesFew: '{{count}} Messer',
  knivesMany: '{{count}} Messer',
  glovesOne: '{{count}} Paar Handschuhe',
  glovesFew: '{{count}} Paar Handschuhe',
  glovesMany: '{{count}} Paar Handschuhe',
  rareItemsOne: '{{count}} Item',
  rareItemsFew: '{{count}} Items',
  rareItemsMany: '{{count}} Items',
  skinsPlusRare: '{{skins}} + {{rare}}',
  catalogH1: 'CS2-Skins',
  catalogCategoryH1: 'CS2-Skins: {{category}}',
  filtersTitle: 'Filter',
  filterWeapon: 'Waffe',
  filterRarity: 'Seltenheit',
  filterCollection: 'Kollektion',
  filterCase: 'Case',
  filterExterior: 'Abnutzung',
  filterStatTrak: 'Mit StatTrak™',
  filterSouvenir: 'Mit Souvenir',
  anyWeapon: 'Jede Waffe',
  anyRarity: 'Jede Seltenheit',
  anyCollection: 'Jede Kollektion',
  anyCase: 'Jedes Case',
  removeFilter: 'Filter „{{name}}“ entfernen',
  sortLabel: 'Sortierung',
  sortRarity: 'Nach Seltenheit',
  sortName: 'Nach Name',
  sortRelease: 'Neueste zuerst',
  sortPrice: 'Nach Preis',
  applyFilters: 'Anzeigen',
  resetFilters: 'Filter zurücksetzen',
  resetShort: 'Zurücksetzen',
  closeFilters: 'Filter schließen',
  catalogEmptyTitle: 'Keine Skins für diese Filter',
  catalogEmptyText: 'Entferne ein paar Filter oder setz alle zurück.',
  prevPage: 'Zurück',
  nextPage: 'Weiter',
  pageOf: 'Seite {{page}} von {{count}}',
  foundCount: 'Gefunden: {{count}}',
  foundCountMasculine: 'Gefunden: {{count}}',
  priceFrom: 'ab {{price}}',
  weaponAllFilters: 'Alle Filter im Katalog',
  breadcrumbs: 'Brotkrumennavigation',
  exteriorFn: 'Fabrikneu',
  exteriorMw: 'Minimale Gebrauchsspuren',
  exteriorFt: 'Einsatzerprobt',
  exteriorWw: 'Abgenutzt',
  exteriorBs: 'Kampfspuren',
  kindNormal: 'Normal',
  kindStatTrak: 'StatTrak™',
  kindSouvenir: 'Souvenir',
  vanillaFinish: 'Vanilla',
  phasesTitle: 'Phasen',
  statsTitle: 'Details',
  statWeapon: 'Waffe',
  statFinish: 'Finish',
  statRarity: 'Seltenheit',
  statFloat: 'Float-Bereich',
  statExteriors: 'Abnutzung',
  statKinds: 'Versionen',
  statCollections: 'Kollektion',
  statContainers: 'Cases',
  statRelease: 'Erscheinungsjahr',
  rareItem: 'seltenes Spezial-Item',
  rareDropNote: 'Fällt als seltenes Spezial-Item ★',
  pricesTitle: 'Steam-Preise',
  pricesHint: 'Preis auf dem Steam-Community-Markt in US-Dollar.',
  priceAsOf: 'Aktualisiert am {{date}}.',
  noPrice: 'Keine aktuellen Daten',
  noPriceMarked: 'Keine aktuellen Daten für die markierten Versionen',
  gameDescriptionTitle: 'Beschreibung im Spiel',
  faqTitle: 'FAQ',
  similarTitle: 'Ähnliche Skins',
  shotTitle: 'Bei SHOT verfügbar',
  shotHint: 'Dieser Skin steckt in diesen SHOT-Cases.',
  dropsTitle: 'Zuletzt gefallen',
  dropsHint: 'Wer ihn bei SHOT bekommen hat und wo.',
  dropsCase: 'Case „{{name}}“',
  dropsCaseBattle: 'Case Battle',
  dropsUpgrade: 'Upgrade',
  dropsContract: 'Contract',
  dropsRushMid: 'Rush Mid',
  dropsRoulette: 'Russisches Roulette',
  timeJustNow: 'gerade eben',
  timeMinutesAgo: 'vor {{count}} Min.',
  timeHoursAgo: 'vor {{count}} Std.',
  timeDaysAgo: 'vor {{count}} Tg.',
  englishName: 'Englischer Name',
  caseReleased: 'Erschienen {{year}}',
  rareTitle: 'Seltene Spezial-Items',
  compositionTitle: 'Enthaltene Skins',
  rareHintKnives: 'Messer fallen aus diesem Case als eigenes seltenes Spezial-Item.',
  rareHintGloves: 'Handschuhe fallen aus diesem Case als eigenes seltenes Spezial-Item.',
  rareHintKnivesAndGloves: 'Messer und Handschuhe fallen aus diesem Case als eigenes seltenes Spezial-Item.',
  rareKnives: 'Messer',
  rareGloves: 'Handschuhe',
  rareKnivesAndGloves: 'Messer und Handschuhe',
  caseCollectionTitle: 'Kollektion des Cases',
  collectionCasesTitle: 'Cases mit dieser Kollektion',
  collectionReleased: 'Erschienen {{year}}',
  tocTitle: 'Inhalt',
  reviewedOn: 'Geprüft am {{date}}',
  reviewedBy: 'Geprüft vom SHOT-Team · {{date}}',
  shortAnswer: 'Kurz gesagt',
  guidesH1: 'CS2-Skin-Ratgeber',
  selectionsH1: 'CS2-Skin-Zusammenstellungen',
  casesH1: 'CS2-Cases',
  collectionsH1: 'CS2-Kollektionen',
  weaponSkinsH1: '{{weapon}}-Skins',
};

export const wikiItem = {
  typeSticker: 'Aufkleber',
  typeAgent: 'Agent',
  typeCharm: 'Anhänger',
  typeMusicKit: 'Musikkit',
  typePatch: 'Aufnäher',
  typeGraffiti: 'Graffiti',
  typePin: 'Pin',
  sectionStickers: 'Aufkleber',
  sectionAgents: 'Agenten',
  sectionCharms: 'Anhänger',
  sectionMusicKits: 'Musikkits',
  sectionPatches: 'Aufnäher',
  sectionGraffiti: 'Graffiti',
  sectionPins: 'Pins',
  kindCase: 'Case',
  kindStickerCapsule: 'Aufkleberkapsel',
  kindAutographCapsule: 'Autogrammkapsel',
  kindSouvenirPackage: 'Souvenir-Paket',
  kindMusicKitBox: 'Musikkit-Box',
  kindPatchCapsule: 'Aufnäher-Pack',
  kindPinsCapsule: 'Pin-Kapsel',
  kindGraffitiBox: 'Graffiti-Box',
  tabAll: 'Alle',
  tabCases: 'Cases',
  tabStickerCapsules: 'Aufkleberkapseln',
  tabAutographCapsules: 'Autogrammkapseln',
  tabSouvenirPackages: 'Souvenir-Pakete',
  tabMusicKitBoxes: 'Musikkit-Boxen',
  tabPatchCapsules: 'Aufnäher-Packs',
  tabPinsCapsules: 'Pin-Kapseln',
  tabGraffitiBoxes: 'Graffiti-Boxen',
  kindsNavLabel: 'Containertypen',
  containersH1: 'CS2-Cases und -Kapseln',
  h1StickerCapsules: 'CS2-Aufkleberkapseln',
  h1AutographCapsules: 'CS2-Autogrammkapseln',
  h1SouvenirPackages: 'CS2-Souvenir-Pakete',
  h1MusicKitBoxes: 'CS2-Musikkit-Boxen',
  h1PatchCapsules: 'CS2-Aufnäher-Packs',
  h1PinsCapsules: 'CS2-Pin-Kapseln',
  h1GraffitiBoxes: 'CS2-Graffiti-Boxen',
  stickersOne: '{{count}} Aufkleber',
  stickersFew: '{{count}} Aufkleber',
  stickersMany: '{{count}} Aufkleber',
  musicKitsOne: '{{count}} Musikkit',
  musicKitsFew: '{{count}} Musikkits',
  musicKitsMany: '{{count}} Musikkits',
  patchesOne: '{{count}} Aufnäher',
  patchesFew: '{{count}} Aufnäher',
  patchesMany: '{{count}} Aufnäher',
  pinsOne: '{{count}} Pin',
  pinsFew: '{{count}} Pins',
  pinsMany: '{{count}} Pins',
  graffitiOne: '{{count}} Graffiti',
  graffitiFew: '{{count}} Graffiti',
  graffitiMany: '{{count}} Graffiti',
  colorsOne: '{{count}} Farbe',
  colorsFew: '{{count}} Farben',
  colorsMany: '{{count}} Farben',
  inGameSince: 'Im Spiel seit {{year}}',
  contentsTitle: 'Was drin ist',
  variantsTitle: 'Varianten',
  groupSticker: 'Aufkleber',
  groupSlab: 'Im Slab',
  effectPaper: 'Papier',
  effectHolo: 'Holo',
  effectFoil: 'Folie',
  effectGold: 'Gold',
  effectGlitter: 'Glitzer',
  effectLenticular: 'Lentikular',
  effectEmbroidered: 'Gestickt',
  stickerAutograph: 'Autogramm',
  stickerTeam: 'Team',
  stickerEvent: 'Turnier',
  stickerOther: 'Sonstige',
  sideT: 'Terroristen',
  sideCt: 'Antiterroreinheit',
  statType: 'Typ',
  statStickerKind: 'Aufkleberart',
  statTournament: 'Turnier',
  statTeam: 'Team',
  statPlayer: 'Spieler',
  statEffects: 'Effekte',
  statSlab: 'Im Slab',
  statSide: 'Seite',
  statArtist: 'Künstler',
  statStatTrak: 'StatTrak™',
  statColors: 'Farben',
  valueYes: 'Verfügbar',
  valueNo: 'Nicht verfügbar',
  whereTitle: 'Wo du es bekommst',
  whereCollection: 'Kollektion',
  whereStickerPack: 'Aufkleberpaket',
  shotHintItem: 'Dieses Item fällt aus diesen SHOT-Cases.',
  souvenirPackagesRow: 'Souvenir-Pakete',
  moreCount: '{{count}} weitere',
  typeHighlight: 'Highlight-Anhänger',
  typePass: 'Pass',
  typeKey: 'Schlüssel',
  sectionHighlights: 'Highlight-Anhänger',
  sectionPasses: 'Pässe',
  sectionKeys: 'Schlüssel',
  kindOther: 'Paket',
  tabOther: 'Sonstige',
  h1Other: 'Weitere CS2-Pakete',
  itemsOne: '{{count}} Item',
  itemsFew: '{{count}} Items',
  itemsMany: '{{count}} Items',
  statEvent: 'Turnier',
  statStage: 'Phase',
  statMap: 'Map',
  statTeams: 'Match',
  statVideo: 'Video',
  watchVideo: 'Den Moment ansehen',
  statOpens: 'Öffnet',
  listH1Stickers: 'CS2-Aufkleber',
  listH1Agents: 'CS2-Agenten',
  listH1Charms: 'CS2-Anhänger',
  listH1MusicKits: 'CS2-Musikkits',
  listH1Patches: 'CS2-Aufnäher',
  listH1Graffiti: 'CS2-Graffiti',
  listH1Highlights: 'CS2-Highlight-Anhänger',
  listH1Pins: 'CS2-Pins',
  listH1Passes: 'CS2-Pässe',
  listH1Keys: 'CS2-Case-Schlüssel',
  listCount: '{{count}} im Spiel',
  typeCollectible: 'Sammlerstück',
  sectionCollectibles: 'Münzen, Medaillen und Trophäen',
  listH1Collectibles: 'CS2-Münzen, -Medaillen und -Trophäen',
  collectibleCoin: 'Münze',
  collectibleTrophy: 'Trophäe',
  collectibleMedal: 'Medaille',
  versionNumber: 'Version {{n}}',
  allItemsTitle: 'Alle Items',
  sectionContainers: 'Cases und Kapseln',
};
